export default __webpack_public_path__ + "static/home-sugar-free-espresso-choc-fudge-ice-cream-1858d96b1b95d28815bcf35138b01ad1.png";